import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { Menu } from '@/components/ui/daisy/menu';

import FileTreeItem from './TreeItem';
import { FileTreeProps } from './types';

const FileTreeBase = forwardRef<HTMLUListElement, FileTreeProps>(
  ({ className, children, size, ...props }, ref) => (
    <Menu
      ref={ref}
      size={size}
      className={twMerge('w-full', className)}
      {...props}
    >
      {children}
    </Menu>
  ),
);

FileTreeBase.displayName = 'FileTree';
FileTreeItem.displayName = 'FileTree.Item';

export const FileTree = Object.assign(FileTreeBase, {
  Item: FileTreeItem,
});
